import { useAuth } from '@dcentralexpedientedigital/fe-shared/hooks/use-auth';
import { useOidcEvents } from '@dcentralexpedientedigital/fe-shared/hooks/use-oidc-events';

import { updateZohoVisitorInfo, resetZohoUserInfo } from '../utils/live-chat';

export const AuthEventManager = () => {
    const { auth } = useAuth();

    useOidcEvents({
        onAccessTokenExpired: () => {
            auth.removeUser();
        },
        onSilentRenewError: () => {
            auth.removeUser();
        },
        onUserLoaded: () => {
            updateZohoVisitorInfo(auth.user ?? null);
        },
        onUserUnloaded: () => {
            resetZohoUserInfo();
        },
    });

    return null;
};
